import options from './list.component';

export default {
    selector: 'dtSensorListContainer',
    options
};
